import { useState } from "react";

export const useFilter = (name) => {
  const [filters, setFilters] = useState({});

  const filterClickHandler = (value) => {

    setFilters((prevFilters) => {
      if (!value) {
        return {
          ...prevFilters,
          [name]: [],
        };
      }

      const prevValues = prevFilters[name] || [];

      if(value === '-1') {
        return prevValues[0] === '-1' ? {[name]: []} : {[name]: [value]}
      }

      if(prevValues?.includes('-1') && value !== '-1') {
        return {[name]: [...prevValues?.filter((v) => v !== '-1'), value]}
      }

      if (prevValues.includes(value)) {
        return {
          ...prevFilters,
          [name]: prevValues.filter((cat) => cat !== value),
        };
      } else {
        return {
          ...prevFilters,
          [name]: [...prevValues, value],
        };
      }
    });
  };

  const selectedValues = filters[name] || [];

  return { filterClickHandler, selectedValues };
};
